<template>
  <div class="main-inner-blk">
    <div class="invoice-filter-block">
      <!-- <div class="filter-blk">
        <v-text-field v-model="filters.search" placeholder="Search Invoice" dense hide-details clearable> </v-text-field>
      </div> -->
      <div class="filter-blk">
        <v-menu v-model="dateRangeModal" :nudge-right="40" :nudge-top="20" :close-on-content-click="false" transition="scale-transition" offset-y>
          <template v-slot:activator="{ on }">
            <v-text-field v-model="dateRangeText" placeholder="Select Date Range" readonly dense v-on="on" hide-details> </v-text-field>
          </template>

          <v-date-picker v-model="dateRangeValue" range color="black"></v-date-picker>
        </v-menu>
      </div>

      <div class="reset-button-blk" style="margin: 0px 10px; display: flex; gap: 10px">
        <v-btn color="#DD9504" @click="resetFilters" small>Reset</v-btn>
      </div>
    </div>
    <div class="invoice-list">
      <v-data-table height="calc(100vh - 264px)" hide-default-footer :headers="headers" :items="invoiceList" fixed-header>
        <template v-slot:body="{ items, headers }">
          <tbody>
            <tr v-for="(item, index) in invoiceList" :key="index">
              <td>{{ item.date }}</td>
              <!-- <td>{{ item.invoiceNo }}</td> -->
              <td>
                <span> {{ item.subtotal }} + {{ item.gstamount }}</span
                ><br />
                <span>= {{ item.total }}</span>
              </td>
              <!-- <td>
                <span> {{ item.receivableAmount }} + {{ item.tds }}</span
                ><br />
                <span>= {{ item.received }}</span>
              </td>
              <td>
                <span>{{ item }}</span>
              </td> -->
              <td>
                <v-btn x-small color="#4c99af" @click="viewInvoice(item)">View Invoice</v-btn>
              </td>
              <td>
                <v-btn x-small color="#af4c4c" @click="cancelInvoice(item)" v-if="item.status !== -1">Cancel Invoice</v-btn>
                <span class="cancelled-block" v-else>Cancelled</span>
              </td>
              <!-- <td>
                <span>Received = 10,000.80</span>
                <div class="action--block">
                  <v-btn x-small color="#318860">Mark</v-btn>
                  <v-btn x-small color="#1d4da5">Close</v-btn>
                </div> -->
              <!-- <span v-if="item > 7" class="received-block" :class="{ 'cancelled-block': item !== 8 }">{{ item === 8 ? "Received" : "Cancelled" }}</span> -->
              <!-- </td> -->
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <div class="pagination">
        <v-pagination v-model="page" :length="Math.ceil(totalCount / 20)" :total-visible="6"></v-pagination>
      </div>
    </div>
    <v-dialog width="800" v-model="invoiceDialog" height="calc(100vh - 500px)" v-if="invoiceDialog">
      <object width="100%" :data="invoiceUrl" style="height: 90vh; overflow: auto"></object>
    </v-dialog>
    <Confirm ref="confirm"></Confirm>
    <Loading v-if="loading"></Loading>
  </div>
</template>

<script>
import moment from "moment";
import axios from "@/axios/axios-global";
import Confirm from "@/components/common/Confirm.vue";
import Loading from "../common/Loading.vue";
export default {
  name: "Invoice",
  components: { Confirm, Loading },
  data() {
    return {
      filters: { search: "", startDate: "", endDate: "" },
      dateRangeModal: false,
      dateRangeValue: [],
      page: 1,
      totalCount: 0,

      headers: [
        { text: "Invoice Date", value: "date", sortable: true },
        // { text: "Invoice No", value: "invoice", sortable: false },
        { text: "Amount + GST", value: "amount", sortable: false },
        { text: "View Invoice", value: "view", sortable: false },
        { text: "Actions", value: "action", sortable: false },
      ],
      invoiceList: [],
      invoiceUrl: "",
      invoiceDialog: false,

      loading: false,
    };
  },
  watch: {
    dateRangeValue() {
      if (this.dateRangeValue[0]) {
        if (this.dateRangeValue[1]) {
          if (this.dateRangeValue[0] > this.dateRangeValue[1]) {
            this.filters.startDate = moment(this.dateRangeValue[1]).format("YYYY-MM-DD");
            this.filters.endDate = moment(this.dateRangeValue[0]).format("YYYY-MM-DD");
          } else {
            this.filters.startDate = moment(this.dateRangeValue[0]).format("YYYY-MM-DD");
            this.filters.endDate = moment(this.dateRangeValue[1]).format("YYYY-MM-DD");
          }
          this.dateRangeModal = false;
          this.getInvoiceList();
        } else {
          this.filters.startDate = moment(this.dateRangeValue[0]).format("YYYY-MM-DD");
          this.filters.endDate = moment().format("YYYY-MM-DD");
        }
      }
    },
    filters: {
      handler() {
        this.invoiceList = [];
        this.page = 1;
        this.getInvoiceList();
      },
      deep: true,
    },
  },
  mounted() {
    this.getInvoiceList();
  },
  methods: {
    resetFilters() {
      this.filters = {
        searchquery: "",
        startDate: "",
        endDate: "",
      };
      this.dateRangeValue = [];
    },
    async getInvoiceList() {
      const payload = {
        search: this.filters.search,
        startDate: this.filters.startDate ? moment(this.filters.startDate).valueOf() : "",
        endDate: this.filters.endDate ? moment(this.filters.endDate).valueOf() : "",
        page: this.page,
        limit: 20,
      };
      const response = await axios.post("invoice/history", payload);
      if (response.status == 200) {
        this.invoiceList = response.data.list;
        this.totalCount = response.data.rowCount;
      } else {
        this.invoiceList = [];
      }
    },
    async cancelInvoice(invoice) {
      let confirmTitle = "Confirm Cancel";
      let confirmText = "Please confirm to cancel the invocie";
      if (await this.$refs.confirm.open(confirmTitle, confirmText)) {
        this.loading = true;
        try {
          const payload = {
            id: invoice.id,
          };
          const response = await axios.post("invoice/cancel", payload);
          console.log(response);
          this.loading = false;
          if (response.status == 200) {
            this.getInvoiceList();
            this.$toasted.show(response.data, {
              position: "bottom-center",
              duration: 4000,
            });
          } else {
            this.$toasted.show(response.data, {
              position: "bottom-center",
              duration: 4000,
            });
          }
        } catch (error) {
          this.loading = false;
          console.log(error);
        }
      }
    },
    viewInvoice(invoice) {
      this.invoiceUrl = invoice.url;
      this.invoiceDialog = true;
    },
  },
  computed: {
    dateRangeText() {
      let start = "";
      let end = "";
      if (this.dateRangeValue.length > 0) {
        if (this.dateRangeValue[0] > this.dateRangeValue[1]) {
          start = moment(this.dateRangeValue[1]).format("MMM DD");
          end = moment(this.dateRangeValue[0]).format("MMM DD");
        } else {
          start = moment(this.dateRangeValue[0]).format("MMM DD");
          end = moment(this.dateRangeValue[1]).format("MMM DD");
        }
        return `${start} ~ ${end}`;
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.invoice-filter-block {
  padding: 10px;
  display: flex;
  gap: 10px;
  .filter-blk {
    width: 300px;
  }
}
.invoice-list {
  margin: 15px 0;
  .action--block {
    display: flex;
    margin: 5px 0;
    justify-content: center;
    gap: 10px;
  }
}

::v-deep .v-data-table {
  .v-data-table__wrapper {
    table {
      //   border: 1px solid #e1e1e1;
      tr {
        td {
          font-size: 12px;
        }
        th,
        td {
          text-align: center !important;
          .v-btn {
            font-weight: bold;
            color: white;
          }
          .received-block {
            color: green;
          }
          .cancelled-block {
            color: rgb(210, 5, 5);
          }
        }
      }
    }
  }
}
</style>
